import type { PropsWithChildren } from 'react';

type BrandCardContentProps = PropsWithChildren;

export const BrandCardContent = ( { children }: BrandCardContentProps ) => {

  return (
    <div className={ 'flex flex-col gap-1' }>
      { children }
    </div>
  )
}
BrandCardContent.displayName = 'BrandCardContent';
